"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M8 7.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 0 0 1h3A1.5 1.5 0 0 0 9 7.5v-3a.5.5 0 0 0-1 0zm0 9a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1 0-1h3A1.5 1.5 0 0 1 9 16.5v3a.5.5 0 0 1-1 0zM16.5 8a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 0-1 0v3A1.5 1.5 0 0 0 16.5 9h3a.5.5 0 0 0 0-1zm-.5 8.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 0 0-1h-3a1.5 1.5 0 0 0-1.5 1.5v3a.5.5 0 0 0 1 0z"
}), 'Reduce');
